import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Pick list"
            description="Pick list was deprecated in favor of the Dropdown component. It was removed in the 1.150.0 package."
            status={{"design":"deprecated","code":"deprecated","docs":"deprecated"}}
        />
    );
}
}
        
export default Page;